"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ROLLUP_FUNCTIONS () {
        return ROLLUP_FUNCTIONS;
    },
    get default () {
        return RollupColumn;
    }
});
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ROLLUP_FUNCTIONS = [
    'count',
    'min',
    'max',
    'avg',
    'countDistinct',
    'sumDistinct',
    'avgDistinct',
    'sum'
];
let RollupColumn = class RollupColumn {
    static async insert(context, data, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(data, [
            'fk_column_id',
            'fk_relation_column_id',
            'fk_rollup_column_id',
            'rollup_function'
        ]);
        const column = await _Column.default.get(context, {
            colId: insertObj.fk_column_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.fieldNotFound(insertObj.fk_column_id);
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, insertObj);
        return this.read(context, data.fk_column_id, ncMeta).then(async (rollupColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_ROLLUP, [
                data.fk_rollup_column_id
            ], `${_globals.CacheScope.COL_ROLLUP}:${data.fk_column_id}`);
            await _NocoCache.default.appendToList(context, _globals.CacheScope.COL_ROLLUP, [
                data.fk_relation_column_id
            ], `${_globals.CacheScope.COL_ROLLUP}:${data.fk_column_id}`);
            return rollupColumn;
        });
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_ROLLUP}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_ROLLUP, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_ROLLUP}:${columnId}`, column);
        }
        return column ? new RollupColumn(column) : null;
    }
    async getRollupColumn(context, ncMeta = _Noco.default.ncMeta) {
        return _Column.default.get(context, {
            colId: this.fk_rollup_column_id
        }, ncMeta);
    }
    async getRelationColumn(context, ncMeta = _Noco.default.ncMeta) {
        return _Column.default.get(context, {
            colId: this.fk_relation_column_id
        }, ncMeta);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
